import {
    getAuthenticated,
    patchAuthenticated
} from '../../../../../services/RestTemplate';
import { alertsApi } from '../../list/redux/backend';

const delegateApi = '/delegate';
const delegateTeamsApi = '/delegate-teams';

export const delegateAlert = (alertId, teamIds) => {
    const delegateAlertUrl = alertsApi + `/${alertId}` + delegateApi;

    return patchAuthenticated(delegateAlertUrl, { teamIds });
};

/*
  The teams an alert can be delegated to, to choose from: [{ id, name }], by name. It needs UPDATE_ALERT_DELEGATE, and not
  VIEW_TEAM_LIST as GET /teams does, which also says the permissions and jurisdictions of each team.
*/
export const getDelegateTeams = () =>
    getAuthenticated(alertsApi + delegateTeamsApi);
